































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { ChainModule } from '@/store/modules/chain.module'
import { UserModule } from '@/store/modules/user.module'
import Switcher from '@/components/Switcher.vue'
import { IOnboarding } from '@zunta/configurations'
import ModalV2 from '@/components/modals/ModalV2.vue'
import TextareaV2 from '@/components/inputsV2/TextareaV2.vue'

@Component({
  components: {
    TextareaV2,
    ModalV2,
    Switcher
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  }
})
export default class OnboardingSettingsModal extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)

  data: IOnboarding | null = null
  isLoading: boolean = false

  mounted () {
    if (!this.$props.value) {
      return
    }
    this.data = JSON.parse(JSON.stringify(this.$props.value))
  }

  async submit () {
    if (!this.data) {
      return
    }
    this.isLoading = true
    const data = {
      onboardingId: this.data.id,
      data: {
        requirePaymentAccount: this.data.requirePaymentAccount,
        onboardedInClinetPortal: this.data.onboardedInClinetPortal,
        requireContract: this.data.requireContract,
        showAllOnboardingSteps: this.data.showAllOnboardingSteps,
        reasonNotRequireContact: this.data.reasonNotRequireContact
      }
    }
    await this.chainModuleInstance.updateOnboarding(data)
    this.isLoading = false
    this.$emit('close')
  }
}
